<template>
    <ul class="container">
        <li class="container_img" v-for="(item, i) in  list " :key="i">
            <img :src="item.url" :alt="item.title">
        </li>
    </ul>
</template>
<script>
import { mapState } from "vuex";

export default {
    props: {},
    components: {},
    computed: {
        ...mapState(["location"]),
    },
    data() {
        return {
            list: [
                {
                    title: '中国银行',
                    url: require('@/assets/imgs/partner/zgyh.png'),
                }, {
                    title: '建设银行',
                    url: require('@/assets/imgs/partner/jsyh.png'),
                }, {
                    title: '四川农商银行',
                    url: require('@/assets/imgs/partner/nsyh.png'),
                }, {
                    title: '农业银行',
                    url: require('@/assets/imgs/partner/nyyh.png'),
                }, {
                    title: '邮政储蓄银行',
                    url: require('@/assets/imgs/partner/yzcxyh.png'),
                }, {
                    title: '工商银行',
                    url: require('@/assets/imgs/partner/gsyh.png'),
                }
            ]
        }
    }
}
</script>
<style lang="less" scoped>
.mb80 {
    margin-bottom: 80px
}

.container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    padding: 0px 0 40px 0;

    .container_img {
        margin-right: 88px;
        margin-bottom: 40px;
    }

    .container_img:last-child {
        margin-right: 0;
    }

    .container_img img {
        width: auto;
        height: 40px;
    }
}
</style>


